import { z } from "zod";

export const savePhoneSchema = z.object({
  phoneNumber: z.string({
    required_error: "You need to enter a phone number.",
  }),
});

export type SavePhoneFormData = z.infer<typeof savePhoneSchema>;
